import {createFileRoute} from '@tanstack/react-router';

import NotificationList from '@/shared/views/notification/NotificationList';

export const Route = createFileRoute('/(shared)/notifications')({
  component: NotificationList
});
